import React, {
  useRef,
  useEffect,
  useCallback,
  useState,
  useMemo,
} from 'react';
import { IMenuItem } from '~/src/api/content/menu';
import { MenuItem } from '~/src/components/Header/components/MenuItem';
import { getABNVariant } from '~/src/helpers/abn-tests';
import { MENU_ITEM, HIDE_ITEM } from '~/src/helpers/city';
import { ABNTest } from '~/src/api/content/geography/get-all-cities';
import * as ST from './styled';
import { useMatchMedia } from '~/src/helpers/hooks/useMatchMedia';
import { EMediaWidth } from '~/src/components/Header';

interface IProps {
  menuItems: IMenuItem[];
  abnTests: ABNTest[];
  typeMenu?: string;
  isFixed?: boolean;
  isVisibility?: boolean;
  isAllItemsView?: boolean;
  onClick: (item: string, menuType?: string) => void;
  onHover: (item: string, menuType?: string) => void;
  clickHandler?: () => void;
  onDisplayAllItems?: () => void;
}

export const arr = [
  {
    name: 'Профиль',
    id: 1,
    link: '/profile',
  },
  {
    name: 'Договор',
    id: 2,
    link: '/management',
  },
  // {
  //   name: 'Сервисные настройки',
  //   id: 3,
  //   link: '/settings',
  // },
  {
    name: 'Помощь',
    id: 4,
    link: 'https://tcenter.ru/voprosy-i-otvety/',
  },
  {
    name: 'Оплата',
    id: 5,
    link: '/payments',
  },
  {
    name: 'Поиск и возврат платежа',
    id: 6,
    link: '/payments/lost',
  },
];
const MainMenu = ({
  abnTests,
  typeMenu = 'Main menu',
  isFixed = false,
  isVisibility = true,
  isAllItemsView,
  onClick,
  onHover,
  clickHandler,
  onDisplayAllItems,
}: IProps): JSX.Element => {
  const [isDisplayArrow, setIsDisplayArrow] = useState(false);

  const btnRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const wrapRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const itemsRef = useRef([]) as React.MutableRefObject<HTMLDivElement[]>;
  const [isDesktop] = useMatchMedia(EMediaWidth.desktop);

  const abnVariant = useMemo(() => {
    return getABNVariant({ abnTests, testName: MENU_ITEM });
  }, [abnTests]);

  const addItemRef = useCallback((elem) => {
    if (elem) {
      itemsRef.current.push(elem);
    }
  }, []);

  const callBack = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const firstIntersect = !isDisplayArrow;
      let isHideElement = false;

      entries.forEach((el) => {
        const htmlElem = el.target as HTMLDivElement;

        if (!el.isIntersecting) {
          htmlElem.style.visibility = 'hidden';

          if (!isHideElement) {
            const clientRect = el.boundingClientRect;
            const rootRect = el.rootBounds;
            if (rootRect?.left && btnRef.current) {
              const diff = clientRect.left - rootRect?.left;
              btnRef.current.style.left = `${diff + 8}px`;
              btnRef.current.style.visibility = '1';
            }
          }
          isHideElement = true;
        } else {
          htmlElem.style.visibility = 'visible';
        }
      });

      if (firstIntersect) {
        setIsDisplayArrow(isHideElement);
      }
    },
    [isDisplayArrow]
  );

  useEffect(() => {
    if (abnVariant && abnVariant?.label === HIDE_ITEM) {
      if (wrapRef.current) {
        const observerInst = new window.IntersectionObserver(callBack, {
          root: wrapRef.current,
          rootMargin: '0px 0px 0px 0px',
          threshold: 0.95,
        });

        itemsRef.current.forEach((node) => {
          observerInst.observe(node);
        });
      }
    }
  }, [callBack, arr, abnVariant]);

  const onDisplayElements = useCallback(() => {
    btnRef.current.style.left = 'auto';
    if (typeof onDisplayAllItems === 'function') {
      onDisplayAllItems();
    }
  }, [onDisplayAllItems]);

  const isHide = abnVariant?.label === HIDE_ITEM;

  return (
    <ST.MainMenuWrapper isFixed={isFixed} withHideItems={isHide}>
      <ST.MainMenuInner ref={wrapRef} withHideItems={isHide}>
        {isDesktop
          ? arr.map((item) => {
              return (
                <MenuItem
                  key={item.id}
                  item={item}
                  isCollapsedMenu={isVisibility}
                  onClick={onClick}
                  onHover={onHover}
                  clickHandler={clickHandler}
                  typeMenu={typeMenu}
                  itemRef={addItemRef}
                />
              );
            })
          : null}
      </ST.MainMenuInner>
      {(isDisplayArrow || isAllItemsView) && (
        <ST.DisplayBtn ref={btnRef} onClick={onDisplayElements}>
          <ST.Img
            width='10'
            height='16'
            src='/static/images/arrow-right.svg'
            alt='отобразить меню'
            isAllItemsView={isAllItemsView}
          />
        </ST.DisplayBtn>
      )}
    </ST.MainMenuWrapper>
  );
};

export default MainMenu;
